import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import sensAI_vault_template from "../components/templates/sensAI_vault_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let imageDescriptionEditor;
let imageCaptionEditor;
let galleryDescriptionEditor;
let bulkImageDescriptionEditor;
let bulkImageCaptionEditor;
let tagPickerSpecAreaEditor;

export default class sensai_vault extends vnModule_knockoutJS {
    protected sensaiVaultTemplate: sensAI_vault_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected eventSource: EventSource;

    protected getModuleName(): string {
        return "sensai_vault";
    }
    public buildContent(): Array<Element> {
        this.sensaiVaultTemplate = new sensAI_vault_template('sensAI_vault', this.viewModel, this)
        return [this.sensaiVaultTemplate.build()]
    }

    public fillPage() {
        this.sensaiVaultTemplate.getTemplateViewModel().articleText(`When one talks about some of the most popular and timeless games of all time, then it pretty much goes without saying that <em>Final Fantasy VII</em> is definitely one of the many landmark titles that will come to the minds of anyone even remotely familiar with the history of gaming. It's easy to see why this is the case — after all, the fact of the matter is that <a href="https://www.thegamer.com/jrpgs-playstation-era-best/">the entire JRPG craze</a> might not even have taken over gaming as we know it had it not been for the release of this landmark title. It's a game that featured everything — from incredible stories to enthralling gameplay, <em>Final Fantasy VII</em> had all of this and more.

<span class="related-single">RELATED: <a href="https://www.thegamer.com/final-fantasy-7-materia-combinations-ranked/amp/">The 10 Most Powerful Materia Combinations In Final Fantasy 7, Ranked</a></span>

Of course, it would be remiss of us to speak about this legendary title without mentioning one of the most memorable elements of this game — the bombastic boss fights. Of course, the names of Emerald and Ruby Weapon might be haunting the minds of most <em>Final Fantasy VII</em> players who couldn't fell these beasts. However, let's not forget that this game also had some mandatory bosses that were quite challenging as well. To refresh your memory, we've ranked ten of the hardest bosses from the game's main storyline.
<h2>Schizo</h2>
<img class="alignnone size-full wp-image-456540" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Schizo-FF7-FFVII.jpg" alt="" width="1280" height="720" />

The two-headed dragon found at the top of Gaea's Cliff is no pushover. Reaching this boss is a pain in itself, with the need to keep the party's temperature up constantly hounding the player at all times. However, all this pales in comparison to the boss fight that's at the end of the encounter.

Schizo is an absolute pain to fight due to the high damage it can deal at times. Taking care of one of the heads is always a priority, since failing to do so will lead to a powerful double-headed breath attack that can knock off a sizeable amount of hit points.
<h2>Rapps</h2>
<img class="alignnone size-full wp-image-456544" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Rapps-FF7-FFVII.jpg" alt="" width="1280" height="720" />

You'd think that Don Corneo's pet wouldn't really pack all that much of a punch, right? Well, you'd be wrong. Rapps is an absolute pain to fight, especially since the party doesn't have any access to Materia as well!

Thus, the only things you can rely on are items, physical attacks, and limit breaks. Fighting this boss is a test of patience, and only the most resourceful of the lot will be able to survive this onslaught.
<h2>Godo</h2>
<img class="alignnone size-full wp-image-456545" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Godo.jpg" alt="" width="1280" height="720" />

Fighting a boss solo can prove to be quite a pain indeed, especially if the character that's in said battle hasn't been used in the game up till then. This is the problem that a gamer can face if they choose to pursue Yuffie's sidequest to the end and fight Godo.

The fact that Yuffie is the only attacker present in the party can make the fight against Godo incredibly taxing. However, with a proper strategy, patience, and a bit of grinding — if need be — this boss can be wiped out, allowing Yuffie to access her ultimate limit break, All Creation.
<h2>Demon's Gate</h2>
<img class="alignnone size-full wp-image-456548" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Demons-Gate-FF7-FFVII.jpg" alt="" width="1280" height="720" />

The <em>Final Fantasy</em> series has a few common elements strewn across the series. One such aspect are the enemies prevalent across these titles, which includes bosses as well. Demon's Gate (also known as Demon Wall in some versions) is one such shared element, with the iteration present in <em>Final Fantasy VII</em> being quite challenging to boot.

The boss is incredibly agile with a number of powerful attacks, most of which hit the entire party for substantial damage. The player needs to be on their toes if they wish to be victorious in this encounter.
<h2>Carry Armor</h2>
<img class="alignnone size-full wp-image-456550" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Carry-Armor-FFVII-FF7.jpg" alt="" width="1280" height="720" />

An annoying boss in every sense of the word, it must be said that Carry Armor is one absolute pain in the butt that serves as another addition to the array of hard mid-game bosses that serve as the make-or-break point of <em>Final Fantasy VII</em>.

<span class="related-single">RELATED: <a href="https://www.thegamer.com/final-fantasy-7-best-hidden-quests-ranked/amp/">The 10 Best Hidden Quests In Final Fantasy 7, Ranked</a></span>

The Lapis Laser attack is damaging enough as is, but that's not even the start of it. We say this because Carry Armor's most damaging attack is the one where he grabs a party member, immobilizes then, and slowly depletes their HP until they perish. This makes Carry Armor a very nerve-wracking boss to fight indeed.
<h2>Safer Sephiroth</h2>
<img class="alignnone size-full wp-image-22718" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2017/05/Safer-Sephiroth-FF7.jpg" alt="" width="1280" height="720" />

Are you really all that surprised to see that the final boss of the game has made this list? After all, the fact of the matter is that — in terms of sheer raw power — Sephiroth easily takes the cake as one of the strongest bosses in the entire game.

The only reason why he doesn't rank further up the list is that by the time the party reaches this boss, they've already powered up to the point where they can definitely take care of Safer Sephiroth without any major issues. However, the gravitas of this boss fight definitely can't be ignored, with his Super Nova attack being one of the most iconic attacks in <em>Final Fantasy</em> history.
<h2>Dyne</h2>
<img class="alignnone size-full wp-image-456553" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Dyne-FF7-FFVII.jpg" alt="" width="1280" height="720" />

Remember when we talked about how fighting certain bosses solo can prove to be quite a pain due to the logistics involved in said boss fights? Well, keeping this in mind, it must be said that Barrett's faceoff with Dyne is once such encounter that absolutely needs to be on this list.

The fight isn't even all that interesting, with the attacks being fairly menial for the most part. The story behind the two men is the only reason why this fight is slightly memorable, but the entire situation is nothing short of a boring trainwreck that is annoying to boot.
<h2>Lost Number</h2>
<img class="alignnone size-full wp-image-456549" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Lost-Number-FFVII-FF7.jpg" alt="" width="1920" height="1080" />

At a glance, Lost Number might seem like your run-of-the-mill gimmick boss. However, it's a gimmick that's quite irritating and can completely wipe your party if you're not careful enough.

<span class="related-single">RELATED: <a href="https://www.thegamer.com/final-fantasy-7-vincent-valentine-trivia/">10 Things Everyone Completely Missed About Vincent Valentine In Final Fantasy 7</a></span>

Lost Number has a physical and magical form, making it imperative for the player to constantly switch out between both these attacks to ensure maximum offense at all times. Failing to do so can lead to dire consequences for the party.
<h2>Midgar Zolom</h2>
<img class="alignnone size-full wp-image-456564" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Midgar-Zolom-FF7-FFVII.png" alt="" width="1430" height="978" />

You knew that this absolute monster would make its way to the list in some form or the other. Serving as one of the more iconic enemies of <em>Final Fantasy VII</em>, the Midgar Zolom serves as the first unassailable trial in <em>Final Fantasy VII</em>... or at least, that's what it might seem like until the player attains a Chocobo.

Alternatively, the player can just try and level up as much as possible and take on this imposing challenge. It might not be worth it, but the satisfaction of beating this beast pretty much speaks for itself.
<h2>Materia Keeper</h2>
<img class="alignnone size-full wp-image-456565" src="https://static0.thegamerimages.com/wordpress/wp-content/uploads/2019/09/Materia-Keeper-FFVII-FF7.jpg" alt="" width="1024" height="768" />

Most <em>Final Fantasy VII</em> fans will have a bitter taste in their mouth when the words 'Materia Keeper' are uttered near them. Encountered at Mt. Nibel, the Materia Keeper is an incredibly annoying enemy to fight for a bevy of reasons.

Just when you think you're about to be victorious against the boss, it turns out that it can use Cure2 to heal at a stupidly fast rate! If that wasn't bad enough as is, the boss also knows Trine, which is incredibly damaging when encountered at this point of time in the game.

No wonder most people hate this boss with a passion.

<span class="next-single">NEXT: <a href="https://www.thegamer.com/final-fantasy-jenova-facts/">10 Facts You Never Knew About Jenova In Final Fantasy 7</a></span>


`)
        this.checkAccessibility();
    }

    private checkAccessibility() {
        this.loadingIn(this.sensaiVaultTemplate.builtTemplate);
        let formReq_url: string = "/api/sensAI-vault/sensai-vault-chat/check-access/";

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, [], this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        XHRHdl.onReadyStateFunction = this.onCheckAccessibility;
        XHRHdl.execute();
    }

    private onCheckAccessibility(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {

                }
            })
            obj.loadingOut(obj.sensaiVaultTemplate.builtTemplate);
        }
    }

    public summarizeArticle() {
        this.loadingIn(this.sensaiVaultTemplate.builtTemplate);

        let formReq_url: string = "/api/sensAI-vault/summarize/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON({
            systemPrompt: this.sensaiVaultTemplate.getTemplateViewModel().systemPrompt(),
            articleText: this.sensaiVaultTemplate.getTemplateViewModel().articleText(),
            temperature: this.sensaiVaultTemplate.getTemplateViewModel().temperature(),
        }));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onGetSummarizeArticle;
        XHRHdl.execute();

    }

    private onGetSummarizeArticle(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.sensaiVaultTemplate.getTemplateViewModel().summaryReturned(true);
                    obj.sensaiVaultTemplate.getTemplateViewModel().summary(responseParsed.summary);
                }

            });
            obj.loadingOut(obj.sensaiVaultTemplate.builtTemplate);
        }
    }

    public initiateSensaiChat(userQuery, isQuickPrompt = false) {

        this.loadingIn(document.getElementById("user-query-container"));
        let articleText = this.sensaiVaultTemplate.getTemplateViewModel().articleText();

        let sessionId = this.sensaiVaultTemplate.getTemplateViewModel().sessionId();
        // Close any existing EventSource connection
        if (this.eventSource) {
            this.eventSource.close();
        }

        this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(true);

        fetch('/api/sensAI-vault/save-chat-session/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ articleText: articleText, sessionId: sessionId, chatHistory: this.sensaiVaultTemplate.getTemplateViewModel().chatHistory() })
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        }).then(data => {
            let sessionId = data.sessionId;
            this.sensaiVaultTemplate.getTemplateViewModel().sessionId(sessionId);
            userQuery = encodeURIComponent(userQuery);
            let formReq_url = `/api/sensAI-vault/sensai-vault-chat/?userQuery=${userQuery}&isQuickPrompt=${isQuickPrompt}`;
            this.eventSource = new EventSource(formReq_url);
            this.eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    //console.log("Streaming response:", data);

                    if (data.response) {
                        this.sensaiVaultTemplate.addToChatHistory(data.response, "system");
                    }

                    if (data === "[DONE]") {
                        console.log("Streaming finished.");
                        this.eventSource.close();
                        this.loadingOut(document.getElementById("user-query-container"));
                    }
                } catch (e) {
                    console.error("Error parsing SSE stream:", e);
                }
            };

            this.eventSource.addEventListener('close', (event) => {
                console.log("Streaming finished gracefully via custom close event.");
                this.eventSource.close();
                this.loadingOut(document.getElementById("user-query-container"));
                this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);
            });


            this.eventSource.onerror = (error) => {
                console.error("EventSource error:", error);
                this.eventSource.close();
                this.loadingOut(document.getElementById("user-query-container"));
                this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);
            };
        })
    }

    protected getImageData(keyword = null) {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.sensaiVaultTemplate.imagePicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/20/images/get/";
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        let viewModel = this.sensaiVaultTemplate.imagePicker.getViewModelForRequest();
        /*if(keyword != null){
                viewModel.filters.keywords(keyword);
            }*/
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.imageXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.sensaiVaultTemplate.imagePicker.hideLoading();
                if (
                    obj.sensaiVaultTemplate.imagePicker.getSelectedTab() == "images" ||
                    obj.isSaveImage
                ) {
                    obj.isSaveImage = false;
                }
            });
        };
    }

    protected updateImagePickerForm(responseParsed) {

        let selectedImages = this.sensaiVaultTemplate.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find((i) => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.sensaiVaultTemplate.imagePicker.setImagesPagination(
                responseParsed.paginatedImages
            );
            this.sensaiVaultTemplate.imagePicker.setImageResults(
                responseParsed.paginatedImages.data
            );
        }

        if (responseParsed.imagesInContent) {
            for (let image of responseParsed.imagesInContent) {
                image.selected = false;
                let imageSelected = selectedImages.find((i) => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.sensaiVaultTemplate.imagePicker.setImagesInContent(
                responseParsed.imagesInContent
            );
        }

        let selectedGallery = this.sensaiVaultTemplate.imagePicker.getSelectedGallery();

        if (
            responseParsed.paginatedGalleries &&
            responseParsed.paginatedGalleries.data
        ) {
            for (let gallery of responseParsed.paginatedGalleries.data) {
                gallery.selected = false;
                if (selectedGallery != null) {
                    if (selectedGallery.id == gallery.id) {
                        gallery.selected = true;
                    }
                }
            }
            this.sensaiVaultTemplate.imagePicker.setGalleryPagination(
                responseParsed.paginatedGalleries
            );
            this.sensaiVaultTemplate.imagePicker.setGalleryResults(
                responseParsed.paginatedGalleries.data
            );
        }

        if (responseParsed.ratios) {
            this.sensaiVaultTemplate.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.sensaiVaultTemplate.imagePicker.setOrientations(
                responseParsed.orientations
            );
        }

        if (responseParsed.uploadSources) {
            this.sensaiVaultTemplate.imagePicker.setUploadSources(
                responseParsed.uploadSources,
                responseParsed.selectedUploadSource
            );
        }

        if (responseParsed.idBrand) {
            this.sensaiVaultTemplate.imagePicker.setIdBrand(responseParsed.idBrand);
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ["KB", "MB", "GB", "TB"];
        if (bytes == 0) return "n/a";
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }

    private onGetSimilarArticles(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.sensaiVaultTemplate.getTemplateViewModel().similarArticlesReturned(true);
                    //obj.sensaiVaultTemplate.getTemplateViewModel().articles(responseParsed.articleCardsHtml);
                    obj.sensaiVaultTemplate.addToChatHistory(responseParsed.articleCardsHtml, "system");
                }

            });
            obj.loadingOut(obj.sensaiVaultTemplate.builtTemplate);
        }
    }

    protected getImagePickerHelper() {
        return this.sensaiVaultTemplate.imagePickerHelper;
    }

    public getValnetImageData(imageId) {

        let idBrand = 20;
        let formReqUrl = "/api/sensAI-vault/valnet-image-object/";

        let subViewModel = {
            imageId: imageId
        };

        return fetch(formReqUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(subViewModel)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(responseParsed => {
                let imageObject = responseParsed.imageObject;

                // Update the Knockout observable with the retrieved image data
                this.sensaiVaultTemplate.getTemplateViewModel().valnetImageData(imageObject);

                // Now that data is ready, proceed with showing the image picker
                this.sensaiVaultTemplate.showImagePicker("single-select", null, imageObject);
                this.sensaiVaultTemplate.imagePicker.editImage(imageObject, "single-select");

                return imageObject; // Return data if needed
            })
            .catch(error => {
                console.error("Error fetching Valnet image data:", error);
                throw error; // Propagate the error so the caller can handle it
            });
    }

    public getBrandId() {

        return 20;

    }

    public getTag(tag, select = false) {
        this.getTags([tag], select);
    }

    protected getTags(idTags, select = false) {

        if (this.tagXHRHdl) {
            this.tagXHRHdl.cancelAndReset();
        }
        //this.sensaiVaultTemplate.tagPicker.showLoading();
        this.sensaiVaultTemplate.showLoading();

        let idBrand = this.getBrandId();
        let usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTags: idTags })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.tagXHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.tags && responseParsed.tags.length > 0) {
                    let tag = responseParsed.tags[0].tag;
                    tag.specsValues = responseParsed.tags[0].specsValues;
                    tag.specDefaults = responseParsed.tags[0].specDefaults;
                    tag.communityRating = responseParsed.tags[0].communityRating ? responseParsed.tags[0].communityRating : { average: null, count: 0 };
                    tag.includeCommunityRating = responseParsed.tags[0].includeCommunityRating ? responseParsed.tags[0].includeCommunityRating : false;
                    obj.sensaiVaultTemplate.tagPicker.setTag({ ...tag, pros: [], cons: [] });
                    
                }
            });

            // obj.sensaiVaultTemplate.tagPicker.hideViewLoading();
            // obj.sensaiVaultTemplate.tagPicker.hideLoading();
            obj.sensaiVaultTemplate.removeLoading();
            if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.sensaiVaultTemplate.addTagPickerValidationClass();
            } else if (obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.sensaiVaultTemplate.removeTagPickerValidationClass();
            }
        }
    }

    protected getTagData() {

        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }

        this.sensaiVaultTemplate.tagPicker.showLoading();

        let idBrand = this.getBrandId();
        let formReq_url: string = '/api/brand/' + idBrand + '/tags/get/';
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.sensaiVaultTemplate.tagPicker.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.tagSearchXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    protected onGetTagDataReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateTagPickerForm(responseParsed);
                obj.sensaiVaultTemplate.tagPicker.hideLoading();
            })
        }
    }

    protected updateTagPickerForm(responseParsed) {

        let selectedTags = this.sensaiVaultTemplate.tagPicker.getSelectedTags();

        if (responseParsed.data) {
            for (let tag of responseParsed.data) {
                tag.selected = false;
                let tagSelected = selectedTags.find(i => i.id == tag.id);
                if (tagSelected) {
                    tag.selected = true;
                }
            }
            this.sensaiVaultTemplate.tagPicker.setTagsPagination(responseParsed.totalPage, responseParsed.currentPage);
            this.sensaiVaultTemplate.tagPicker.setTagResults(responseParsed.data);
        }

    }

    protected initializeCkEditors() {

        for (let name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy(true);
        }

        this.sensaiVaultTemplate.initTagPickerCkEditors();
        // @TODO revisit this!
        this.initializeImagePickerCkEditors();
    }

    protected setUpCkEditorTagsPickerEditTextArea() {

        const element = document.querySelector('#tagPickerTagTypeFieldTextArea');
        if (element) {
            classicEditor.create(
                element,
                {
                    toolbar: ['bold', '|', 'italic', 'link'],
                    link: {
                        addTargetToExternalLinks: true
                    }
                }).then(newEditor => {
                    tagPickerSpecAreaEditor = newEditor;
                }).catch(error => {
                    console.error(error);
                });
        }
    }

    protected initializeImagePickerCkEditors() {


        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                { name: 'Heading 1', element: 'h1' },
                { name: 'Heading 2', element: 'h2' },
                { name: 'Heading 3', element: 'h3' },
                { name: 'Preformatted', element: 'pre' },
                // Inline styles.
                { name: 'Related: One link', element: 'span', attributes: { 'class': 'related-single' } },
                { name: 'Next - One link', element: 'span', attributes: { 'class': 'next-single' } },
                { name: 'Affiliate - One link', element: 'span', attributes: { 'class': 'affiliate-single' } },
                { name: 'Spoiler Alert', element: 'span', attributes: { 'class': 'article-alert' } },
                { name: 'Tip', element: 'div', attributes: { 'class': 'emaki-custom tip' } },
                { name: 'Warning', element: 'div', attributes: { 'class': 'emaki-custom warning' } },
                { name: 'Note', element: 'div', attributes: { 'class': 'emaki-custom note' } },
                { name: 'Expandable', element: 'div', attributes: { 'class': 'emaki-custom expandable' } },
                { name: 'Pullquote', element: 'div', attributes: { 'class': 'emaki-custom pullquote' } },
                { name: 'Promoted', element: 'div', attributes: { 'class': 'emaki-custom promoted' } },

            ]);
        }

        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if (dialogName == "cellProperties") {
                // "bgColor"
                // "borderColor"
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        // Image Description Editor
        this.initCkEditor('image_description');
        imageDescriptionEditor = CKEDITOR.instances.image_description;

        // Image Caption Editor
        this.initCkEditor('image_caption');
        imageCaptionEditor = CKEDITOR.instances.image_caption;

        // Gallery Description
        this.initCkEditor('gallery_description');
        galleryDescriptionEditor = CKEDITOR.instances.gallery_description;

        this.initCkEditor('bulk_image_description');
        bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;

        this.initCkEditor('bulk_image_caption');
        bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;

    }

    protected initCkEditor(idElement) {

        let height, toolbarMA;
        let disallowedContent = 'p';
        //contextmenu,tabletools,tableselection
        let removePlugins = 'elementspath,liststyle,image,forms';
        if (idElement == 'article_directory_item_description' || idElement == 'sandbox_directory_item_description') {
            disallowedContent += ',ul,ol,li';
            removePlugins += ',list';
            toolbarMA = [['Source', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'SpecialChar', 'ImgBtn', 'VideoBtn', 'Bold', 'Italic', 'Strike', '-', 'LinkBtn', 'Maximize']];
            height = '500px';
        }
        else if (idElement == "image_description" || idElement == "image_caption" || idElement == "gallery_description") {
            disallowedContent += ',ul,ol,li';
            removePlugins += ',list';
            toolbarMA = [['Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'SpecialChar', 'Bold', 'Italic', 'Strike', '-', 'LinkBtn', 'Maximize']];
            height = '125px';
        }
        else if (idElement == "bulk_image_description" || idElement == "bulk_image_caption") {
            disallowedContent += ',ul,ol,li';
            removePlugins += ',list';
            toolbarMA = [['Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'SpecialChar', 'Bold', 'Italic', 'Strike', '-', 'LinkBtn', 'Maximize']];
            height = '75px';
        }
        else {
            height = '500px';
            //height = '1500px';
            toolbarMA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'VideoBtn', 'TagBtn', 'EmbedBtn', 'UpdateBtn', 'KeyPointsBtn', 'Styles'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn', 'Maximize']];
        }

        CKEDITOR.replace(idElement, {
            height: height,
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'span(*)[!data-field];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*]',
            disallowedContent: disallowedContent,
            removePlugins: removePlugins,
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            },
            toolbar_MA: toolbarMA
        });
            CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
            CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=7.5'];
            CKEDITOR.config.skin = "emakiCustomComprehensive";
            CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
            CKEDITOR.config.forcePasteAsPlainText = false;
            CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
    }

    protected onAutocompleteInputClear(idElement) {

        if (idElement == "tagTypeFilter") {
            this.sensaiVaultTemplate.getTemplateViewModel().tagType(null)
            this.sensaiVaultTemplate.getTemplateViewModel().level1Filter.setOptions([])
            this.sensaiVaultTemplate.getTemplateViewModel().level2Filter.setOptions([])
        } else if (idElement == "vignetteFilter") {
            this.sensaiVaultTemplate.tagPicker.tagEdit.setSelectedVignette(null);
        } else if (idElement == "defaultVignetteFilter") {
            this.sensaiVaultTemplate.tagPicker.tagEdit.setSelectedDefaultVignette(null);
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/sensAI_vault.ts